var styles = {"navbarMore":"navkit__NavbarMore__navbarMore","isHidden":"navkit__NavbarMore__isHidden","navbarMoreDropdown":"navkit__NavbarMore__navbarMoreDropdown"};

export { styles as default };
